import type React from 'react'
import { showSuccessToast } from '@bpinternal/ui-kit-next'

export function copyToClipboard(
  valueToCopy: string,
  descriptionOfValue: string,
  options?: { preventDefault?: boolean; event: Event | React.MouseEvent; showToast?: boolean }
) {
  if (options?.preventDefault !== false) {
    options?.event.preventDefault()
  }
  return navigator.clipboard.writeText(valueToCopy).then(() => {
    if (options?.showToast !== false) {
      return showSuccessToast(`The ${descriptionOfValue} has been copied to your clipboard.`)
    }
  })
}
